// OMNI Design System Spacing & Radius Tokens for Chakra UI v3
// Mapped from omni_standard_css.css

export const omniSpacing = {
  spacing: {
    // Standard spacing scale (based on 0.25rem = 4px increments)
    '0': { value: '0' },
    '0.5': { value: '0.125rem' }, // 2px
    '1': { value: '0.25rem' }, // 4px
    '1.5': { value: '0.375rem' }, // 6px
    '2': { value: '0.5rem' }, // 8px
    '2.5': { value: '0.625rem' }, // 10px
    '3': { value: '0.75rem' }, // 12px
    '3.5': { value: '0.875rem' }, // 14px
    '4': { value: '1rem' }, // 16px
    '5': { value: '1.25rem' }, // 20px
    '6': { value: '1.5rem' }, // 24px
    '7': { value: '1.75rem' }, // 28px
    '8': { value: '2rem' }, // 32px
    '9': { value: '2.25rem' }, // 36px
    '10': { value: '2.5rem' }, // 40px
    '11': { value: '2.75rem' }, // 44px
    '12': { value: '3rem' }, // 48px
    '14': { value: '3.5rem' }, // 56px
    '16': { value: '4rem' }, // 64px
    '20': { value: '5rem' }, // 80px
    '24': { value: '6rem' }, // 96px
    '28': { value: '7rem' }, // 112px
    '32': { value: '8rem' }, // 128px
    '36': { value: '9rem' }, // 144px
    '40': { value: '10rem' }, // 160px
    '44': { value: '11rem' }, // 176px
    '48': { value: '12rem' }, // 192px
    '52': { value: '13rem' }, // 208px
    '56': { value: '14rem' }, // 224px
    '60': { value: '15rem' }, // 240px
    '64': { value: '16rem' }, // 256px
    '72': { value: '18rem' }, // 288px
    '80': { value: '20rem' }, // 320px
    '96': { value: '24rem' }, // 384px

    // OMNI-specific spacing (table cell padding, etc.)
    'table-cell-x': { value: '2.1rem' }, // From --table-cell-padding: 0.6rem 2.1rem
    'table-cell-y': { value: '0.6rem' }, // From --table-cell-padding: 0.6rem 2.1rem
  },

  radii: {
    // OMNI radius scale
    none: { value: '0' },
    sm: { value: '4px' }, // --radius-small: 4px
    base: { value: '8px' }, // --radius: 8px (default)
    md: { value: '8px' }, // Same as base
    lg: { value: '16px' }, // --radius-large: 16px
    xl: { value: '24px' }, // Extended
    '2xl': { value: '32px' }, // Extended
    '3xl': { value: '48px' }, // Extended
    full: { value: '9999px' }, // For circular elements

    // OMNI-specific radii
    'table-row': { value: '6px' }, // --table-row-border-radius: 6px
  },

  sizes: {
    // Container and component sizes
    container: {
      sm: { value: '640px' },
      md: { value: '768px' },
      lg: { value: '1024px' },
      xl: { value: '1280px' },
      '2xl': { value: '1536px' },
    },

    // Button heights
    button: {
      sm: { value: '2rem' }, // 32px
      md: { value: '2.5rem' }, // 40px
      lg: { value: '3rem' }, // 48px
      xl: { value: '3.5rem' }, // 56px
    },

    // Input heights
    input: {
      sm: { value: '2rem' }, // 32px
      md: { value: '2.5rem' }, // 40px
      lg: { value: '3rem' }, // 48px
    },

    // Icon sizes
    icon: {
      xs: { value: '0.75rem' }, // 12px
      sm: { value: '1rem' }, // 16px
      md: { value: '1.25rem' }, // 20px
      lg: { value: '1.5rem' }, // 24px
      xl: { value: '2rem' }, // 32px
      '2xl': { value: '2.5rem' }, // 40px
    },
  },

  borderWidths: {
    '0': { value: '0' },
    '1': { value: '1px' }, // Standard border
    '2': { value: '2px' },
    '4': { value: '4px' },
    '8': { value: '8px' },

    // OMNI-specific border widths
    'table-cell': { value: '1px' }, // --table-cell-border-width: 1px
    'table-head': { value: '0' }, // --table-head-cell-border-width: 0
    'form-input': { value: '1px' }, // --form-input-border: 1px solid
  },

  // Z-index scale for layering
  zIndex: {
    hide: { value: -1 },
    auto: { value: 'auto' },
    base: { value: 0 },
    docked: { value: 10 },
    dropdown: { value: 1000 },
    sticky: { value: 1100 },
    banner: { value: 1200 },
    overlay: { value: 1300 },
    modal: { value: 1400 },
    popover: { value: 1500 },
    skipLink: { value: 1600 },
    toast: { value: 1700 },
    tooltip: { value: 1800 },
  },

  // Transition durations
  durations: {
    'ultra-fast': { value: '50ms' },
    faster: { value: '100ms' },
    fast: { value: '150ms' },
    normal: { value: '200ms' },
    slow: { value: '300ms' },
    slower: { value: '400ms' },
    'ultra-slow': { value: '500ms' },
  },

  // Easing functions
  easings: {
    'ease-in': { value: 'cubic-bezier(0.4, 0, 1, 1)' },
    'ease-out': { value: 'cubic-bezier(0, 0, 0.2, 1)' },
    'ease-in-out': { value: 'cubic-bezier(0.4, 0, 0.2, 1)' },
  },
};
